export default [
  {
    path: "pedidos",
    name: "orders",
    redirect: { name: "orders-list" },
    children: [
      {
        path: "",
        name: "orders-list",
        component: () => import("@/modules/orders/views/OrdersList.vue"),
      },
      {
        path: ":id",
        name: "orders-show",
        component: () => import("@/modules/orders/views/OrderShow.vue"),
      },{
        path: ':id/payment-info',
        name: 'order-payment-info',
        component : () => import('@/modules/orders/views/OrderPaymentInfo.vue')
      },{
        path: ':id/map',
        name: 'order-show-map',
        component: () => import('@/modules/orders/views/OrderShowMap.vue')
      },{
        path: ':id/edit',
        name: 'order-edit',
        component: () => import('@/modules/orders/views/OrderEdit.vue'),
        meta: {
          roles: [
            "superadmin",
            "admin",
            "supervisor_granos",
            "supervisor_abarrotes",
          ],
        },
      }
    ],
  },
];
